import RealTimeEmotion from "./RealTimeEmotion";

export default RealTimeEmotion;